export default "__VITE_ASSET__glY69y46__"